<template>
  <div>
    <list
      ref="list"
      unit="访客"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="仓库名称">
          <warehouse-select v-model="params.WarehouseId" />
        </el-form-item>
        <el-form-item label="往来单位">
          <customer  @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
        <el-form-item label="单位类型">
          <el-select size="mini" v-model="params.TradeUnitType" placeholder="请选择单位类型">
            <el-option label="供应商" :value="0"></el-option>
            <el-option label="批发" :value="1"></el-option>
            <el-option label="零售" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="WarehouseName" label="仓库名称" />
        <el-table-column prop="GoodsName" label="商品名称" />
        <el-table-column prop="UnitName" label="单位" />
        <el-table-column prop="Quantity1" label="数量" />
        <el-table-column prop="Quantity2" label="包装数量" />
        <el-table-column prop="Quantity1" label="主数量" />
        <el-table-column prop="UnitPrice" label="成本主单价" />
        <el-table-column prop="Amount" label="成本金额" />
        <slot name="column"></slot>
      </template>
    </list>
    <unit-dialog ref="unitDialog" in-dialog selectable @select="setUnit" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import warehouseSelect from "@/components/basicinfo/basic/warehouse/select";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: {
    list,
    unitDialog,
    warehouseSelect,
    customer
  },
  data() {
    return {
      api: require("@/api/sy/ware").default,
      params: {
        TradeUnitName: "",
        WarehouseId: null,
        TradeUnitType: 0,
        TradeUnitId: "",
      },
    };
  },
  mounted() {},
  methods: {
    setSupplier(data) {
      
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      
      this.params.TradeUnitId = e.Id;
      this.params.TradeUnitName = e.Name;
    },
  },
};
</script>